module.exports = __webpack_public_path__ + "img/y1.4be3a184.webp";